import React from 'react';
import { ChevronDown } from 'lucide-react';
import { faqItems } from '../data/mock';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  return (
    <section id="faq" className="py-20 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-4xl mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block bg-sky-100 text-sky-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            FAQ
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            Questions <span className="text-sky-600">Fréquentes</span>
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg">
            Retrouvez les réponses aux questions les plus courantes de nos clients
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqItems.map((item, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="bg-white rounded-2xl shadow-md hover:shadow-lg transition-shadow duration-300 border border-slate-100 px-6 overflow-hidden"
            >
              <AccordionTrigger className="py-5 text-left hover:no-underline group">
                <span className="text-gray-800 font-semibold text-lg pr-4 group-hover:text-sky-600 transition-colors">
                  {item.question}
                </span>
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-gray-600 leading-relaxed">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Additional help */}
        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">
            Vous avez d'autres questions ? N'hésitez pas à nous contacter !
          </p>
          <a 
            href="#contact" 
            className="inline-flex items-center gap-2 text-sky-600 hover:text-sky-700 font-semibold transition-colors"
          >
            Nous contacter
            <ChevronDown size={18} className="rotate-[-90deg]" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;